const getters = {
    //app
    isRefresh: state => state.app.isRefresh,
    menuList: state => state.app.menuList,
    menuPathList: state => state.app.menuPathList,
    infoDetails_: state => state.app.infoDetails_,
    //用户
    userInfo:state => state.user.userInfo,
    teacherRole:state => state.user.teacherRole,
}
export default getters;
